import React from 'react';
import '../styles/CivilheroExtra.css'; // renamed from MechheroExtra.css
import slide1 from '../assets/cg1.jpg';
import slide2 from '../assets/cg10.avif';
import slide3 from '../assets/cg4.jpg';
import slide4 from '../assets/cg3.jpg';
import slide5 from '../assets/cg8.avif';
import slide6 from '../assets/cg5.jpg';
import slide7 from '../assets/cg7.avif';
import slide8 from '../assets/cg2.jpg';

const CivilheroExtra = () => {
  const images = [slide1, slide2, slide3, slide4, slide5, slide6, slide7, slide8];

  return (
    <div className="civilhero-extra-container">
      <div className="parallax-bg" />
      <div className="content-wrapper">
        <div className="left-content">
          <h2>Innovative Civil Solutions</h2>
          <p>
            Discover our advanced civil engineering services designed to enhance structural integrity, sustainability, and project efficiency. From planning to execution, we deliver smart, reliable infrastructure solutions tailored to your needs.
          </p>
        </div>

        <div className="right-carousel">
          <div className="carousel-viewport">
            <div className="carousel-track">
              {images.concat(images).map((img, idx) => (
                <div className="carousel-slide" key={idx}>
                  <img src={img} alt={`Slide ${idx + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CivilheroExtra;
